import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { Link } from 'react-router'
import { BootstrapTable, TableHeaderColumn, defaultSortName, defaultSortOrder  } from 'react-bootstrap-table'
import {
  Breadcrumb,
  Button,
  Col,
  Panel,
  Form,
  FormControl,
  FormGroup,
  Modal,
  browserHistory
} from 'react-bootstrap'
import Collapsible from './../collapsible'
import Validators from '../../utils/validators'
import DatePicker from 'react-bootstrap-date-picker'
import PartnerTasksTable from './partnertaskstable'

@observer(['globals', 'tasks'])
export default class PartnerPending extends Component {
  constructor(props) {
    super(props)
  }

  reload(callback) {
    this.props.tasks.loadAllPendingPartnerTasks(() => {
      if (callback != null) {
        callback()
      }
    })
  }

  render() {
    return (
      <div>
        <PartnerTasksTable data={ this.props.tasks.pendingpartner } reload={ this.reload.bind(this) } />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/tasks/partnerpending.js